var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8854 9.17467H3.81875L10.6938 2.29967C11.0604 1.93301 11.0604 1.47467 10.6938 1.10801C10.3271 0.741341 9.86875 0.741341 9.50208 1.10801L1.25208 9.35801C1.16042 9.44967 1.06875 9.54134 1.06875 9.72467C0.977083 9.90801 0.977083 10.0913 1.06875 10.2747C1.06875 10.3663 1.16042 10.458 1.25208 10.5497L9.50208 18.7997C9.68542 18.983 9.86875 19.0747 10.0521 19.0747C10.2354 19.0747 10.5104 18.983 10.6021 18.7997C10.9688 18.433 10.9688 17.9747 10.6021 17.608L3.72708 10.733H22.7938C23.2521 10.733 23.6188 10.3663 23.6188 9.90801C23.6188 9.44967 23.3438 9.17467 22.8854 9.17467Z",
    fill: "#DEE0EB",
    stroke: "#DEE0EB",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9c755e266d5e1f332e94a4f6e77ac54a.svg";
export { ForwardRef as ReactComponent };